import { dropBoolean, dropTipoMascara } from 'utils/drops';

const getTipoContatoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'tipo_mascara',
    label: 'Tipo de Máscara',
    type: 'select',
    options: dropTipoMascara,
    multiple: true,
  },
  { name: 'envionf', label: 'Envio NF', type: 'select', options: dropBoolean },
  {
    name: 'enviobol',
    label: 'Envio Boleto',
    type: 'select',
    options: dropBoolean,
  },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getTipoContatoFilterFields;
